
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { configStore, uiStore } from "@/store/store";
import { saveToWordPressWithErrorsLoggedToUiStore } from "@/lib/wordpress/save";
import { keyboardShortcuts } from "@/lib/keyboard-shortcuts/keyboard-shortcuts";
import { KEYBOARD_SHORTCUTS } from "@/lib/keyboard-shortcuts/global-shortcuts";
import StandardButton from "@/components/UI/StandardButton.vue";
import {
  removeChangesNotSavedWarning,
  warnIfExitingWithUnsavedChanges
} from "@/util/warn-unsaved-changes";
import { breakdanceUndo } from "@/lib/undo/undo";
import IconButton from "@/components/UI/IconButton.vue";
import Icon from "@/components/UI/Icon.vue";
import { stopInlineEditing } from "@/lib/inline-editor/inline-editor";
import { blurContentEditableElement } from "@/util/blur-content-editable";

@Component({
  components: {
    StandardButton,
    IconButton,
    Icon
  }
})
export default class Save extends Vue {
  get saveInProgress() {
    return uiStore.saveInProgress;
  }

  get unsavedChangesPresent() {
    return uiStore.unsavedChangesPresent;
  }

  async save() {
    document.dispatchEvent(new Event("breakdanceSaveButtonClicked"));

    // TODO: All this extra logic probably should not be here.

    // This ensures any changes in the document are saved before the user clicks save.
    blurContentEditableElement();

    if (uiStore.inlineEditingContext?.elementId) {
      await stopInlineEditing();
    }

    await saveToWordPressWithErrorsLoggedToUiStore();
  }

  warnIfUnsavedFunction!: (e: Event) => void;

  unsubscribe: null | (() => void) = null;

  mounted() {
    keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_S);
    keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_S, this.save);

    this.unsubscribe = this.$store.subscribe(mutationPayload => {
      if (!breakdanceUndo.shouldMutationBeIgnored(mutationPayload)) {
        uiStore.setUnsavedChangesPresent(true);
      }
    });

    this.warnIfUnsavedFunction = warnIfExitingWithUnsavedChanges(
      () => uiStore.unsavedChangesPresent
    );
  }

  beforeDestroy() {
    keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_S);
    this.unsubscribe && this.unsubscribe();
    removeChangesNotSavedWarning(this.warnIfUnsavedFunction);
  }

  get builderMode() {
    return configStore.builderMode;
  }
}
